(function () {
    'use strict';

    angular
        .module('app.clubAdmin')
        .component('sc3MembershipCreditModal', {
            templateUrl: 'app/club-admin/club-info/club-stats/membership-credit-modal.component.html',
            bindings: { close: '&' }
        });
})();